import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
	userImage: {
		borderRadius: "50%"
	},
	contentWrapper: {
		display: "flex",
		width: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		gap: "var(--spacing-x2, 8px)"
	}
});
